/*jshint browserify: true */
'use strict';

var PDFedit = window.PDFedit || {};

PDFedit.elements = require('./Elements');
PDFedit.coordinates = require('./Coordinates');
PDFedit.uimodes = require('./UImodes');
PDFedit.ContextMenu = require('./pdf-context-menu.js');
PDFedit.document = {
    Page: require('./pdf-document-page.js')
};

window.PDFedit = PDFedit;